var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentUser.role === _vm.roles.admin)?_c('AdminDashboard'):(_vm.currentUser.role === _vm.roles.stateHead)?_c('StateHeadDashboard'):(_vm.currentUser.role === _vm.roles.agencyHead)?_c('AgencyHeadDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }